import React, { Fragment } from 'react';
import { bool, oneOf, func } from 'prop-types';
import styled from 'styled-components';
import { variant } from 'styled-system';
import theme from '@airasia-common/libraries/theming/theme';
import LOBIcon from '../Icon';
import Styled from '../../utils/Styled';
import { Variant } from '../../utils/constants';
import Wrapper from '../Wrapper';

const IconWrapper = Styled(Wrapper, {
  position: 'absolute',
  display: 'flex',
  right: 11,
  alignItems: 'center',
});

const variants = {
  error: {
    color: 'tertiaryOrange',
  },
  success: {
    color: 'tertiaryGreen',
  },
  default: {
    color: 'greyDark',
  },
};

const MdCheckIcons = styled(LOBIcon)(
  variant({
    variants,
  })
);

MdCheckIcons.displayName = 'MdCheckIcons';

const MdErrorIcons = styled(LOBIcon)(
  variant({
    variants,
  })
);

MdErrorIcons.displayName = 'MdErrorIcons';

const Icon = ({
  customIcon: CustomIconComponent,
  focused,
  variant = Variant.Default,
}) => {
  return (
    <IconWrapper>
      {CustomIconComponent ? (
        <CustomIconComponent
          fontsize="titleNormal"
          color={theme.colors.greyDark}
        />
      ) : (
        <Fragment>
          {variant === Variant.Error && (
            <MdErrorIcons
              icon="ErrorIcon"
              fontsize="titleNormal"
              variant={variant}
            />
          )}
          {!focused && variant === Variant.Success && (
            <MdCheckIcons
              icon="CheckIcon"
              fontsize="titleNormal"
              variant={variant}
            />
          )}
        </Fragment>
      )}
    </IconWrapper>
  );
};

Icon.displayName = 'Icon';

Icon.propTypes = {
  customIcon: func,
  focused: bool,
  variant: oneOf([Variant.Success, Variant.Error, Variant.Default]),
};

export default Icon;
